"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWalletInternal = void 0;
const tslib_1 = require("tslib");
const fast_json_stable_stringify_1 = (0, tslib_1.__importDefault)(require("fast-json-stable-stringify"));
const react_1 = require("react");
const error_1 = require("../error");
const providers_1 = require("../providers");
const useLocalStorageState_1 = require("./useLocalStorageState");
const useWalletInternal = ({ onConnect, onDisconnect, network, endpoint, onError, }) => {
    var _a;
    const [walletConfigStr, setWalletConfigStr] = (0, useLocalStorageState_1.useLocalStorageState)("use-solana/wallet-config", null);
    const walletConfig = (0, react_1.useMemo)(() => {
        try {
            return walletConfigStr
                ? JSON.parse(walletConfigStr)
                : null;
        }
        catch (e) {
            console.warn("Error parsing wallet config", e);
            return null;
        }
    }, [walletConfigStr]);
    const { walletType, walletArgs } = walletConfig !== null && walletConfig !== void 0 ? walletConfig : {
        walletType: null,
        walletArgs: null,
    };
    const [connected, setConnected] = (0, react_1.useState)(false);
    const [walletProviderInfo, wallet] = (0, react_1.useMemo)(() => {
        if (walletType) {
            const provider = providers_1.WALLET_PROVIDERS[walletType];
            console.debug("New wallet", provider.url, network);
            return [provider, new provider.makeAdapter(provider.url, endpoint)];
        }
        return [undefined, undefined];
    }, [walletType, network, endpoint]);
    (0, react_1.useEffect)(() => {
        if (wallet && walletProviderInfo) {
            setTimeout(() => {
                void wallet.connect(walletArgs).catch((e) => {
                    onError(new error_1.WalletAutomaticConnectionError(e, walletProviderInfo));
                });
            }, 500);
            wallet.on("connect", () => {
                if (wallet === null || wallet === void 0 ? void 0 : wallet.publicKey) {
                    setConnected(true);
                    onConnect(wallet, walletProviderInfo);
                }
            });
            wallet.on("disconnect", () => {
                setConnected(false);
                onDisconnect(wallet, walletProviderInfo);
            });
        }
        return () => {
            if (wallet && wallet.connected) {
                const disconnect = wallet.disconnect();
                if (disconnect) {
                    disconnect.catch((e) => {
                        onError(new error_1.WalletDisconnectError(e, walletProviderInfo));
                    });
                }
            }
        };
    }, [
        onConnect,
        onDisconnect,
        onError,
        wallet,
        walletArgs,
        walletProviderInfo,
    ]);
    const activate = (0, react_1.useCallback)((nextWalletType, nextWalletArgs) => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
        const nextWalletConfigStr = (0, fast_json_stable_stringify_1.default)({
            walletType: nextWalletType,
            walletArgs: nextWalletArgs !== null && nextWalletArgs !== void 0 ? nextWalletArgs : null,
        });
        if (walletConfigStr === nextWalletConfigStr) {
            // reconnect
            try {
                yield (wallet === null || wallet === void 0 ? void 0 : wallet.connect(nextWalletArgs));
            }
            catch (e) {
                onError(new error_1.WalletActivateError(e, nextWalletType, nextWalletArgs));
            }
        }
        setWalletConfigStr(nextWalletConfigStr);
    }), [onError, setWalletConfigStr, wallet, walletConfigStr]);
    const disconnect = (0, react_1.useCallback)(() => {
        wallet === null || wallet === void 0 ? void 0 : wallet.disconnect();
        setWalletConfigStr(null);
    }, [setWalletConfigStr, wallet]);
    return {
        wallet,
        walletProviderInfo,
        connected,
        publicKey: (_a = wallet === null || wallet === void 0 ? void 0 : wallet.publicKey) !== null && _a !== void 0 ? _a : undefined,
        activate,
        disconnect,
    };
};
exports.useWalletInternal = useWalletInternal;
//# sourceMappingURL=useWalletInternal.js.map